import UserMenu from "../../views/account/UserMenu";
import UserEdit from "../../views/account/UserEdit";
import UserAddresses from "../../views/account/Addresses";
import UserRegistration from "../../views/account/Registration";
import UserLogin from "../../views/account/Login";
import UserPswRemember from "../../views/account/password/Remember";
import UserPswReset from "../../views/account/password/Reset";
import UserPayments from "../../views/account/Payments";

export default [
    {
        path: '/utente',
        name: 'user',
        component: UserMenu,
        meta: {requiresAuth: true, showNav: true, showOptionbar: true, headerTitleKey: 'layout_profilo_tooltip'}
    },
    {
        path: '/utente/modifica',
        name: 'user.edit',
        component: UserEdit,
        meta: {requiresAuth: true, showNav: true, showOptionbar: true, headerTitleKey: 'account.dati_utente'}
    },
    {
        path: '/utente/indirizzi',
        name: 'user.addresses',
        component: UserAddresses,
        meta: {requiresAuth: true, showNav: true, showOptionbar: true, requiresDeliveryActive: true, headerTitleKey: 'account.gestione_indirizzi'}
    },
    {
        path: '/utente/metodi-pagamento',
        name: 'user.payments',
        component: UserPayments,
        meta: {requiresAuth: true, showNav: true, showOptionbar: true, requiresStripe: true, headerTitleKey: 'metodi_pagamento_title'}
    },
    {
        path: '/utente/registrazione',
        name: 'user.registration',
        component: UserRegistration,
        meta: {showNav: true, showOptionbar: true, headerTitleKey: 'account.registrazione'}
    },
    {
        path: '/utente/login',
        name: 'user.login',
        component: UserLogin,
        meta: {showNav: true, showOptionbar: true, headerTitleKey: 'account.accedi_dati'}
    },
    {
        path: '/utente/password/remember',
        name: 'user.password.remember',
        component: UserPswRemember,
        meta: {showNav: true, showOptionbar: true, headerTitleKey: 'account.recupera_password'}
    },
    {
        path: '/utente/password/reset/:token',
        name: 'user.password.reset',
        component: UserPswReset,
        meta: {showNav: true, showOptionbar: true, headerTitleKey: 'account.nuova_password_label'}
    }
]
